import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './IconAccountEdit.module.css';

const IconAccountEdit = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.49997 7.5C6.49997 4.46243 8.9624 2 12 2C15.0375 2 17.5 4.46243 17.5 7.5C17.5 10.5376 15.0375 13 12 13C8.9624 13 6.49997 10.5376 6.49997 7.5ZM12 3.5C9.79083 3.5 7.99997 5.29086 7.99997 7.5C7.99997 9.70914 9.79083 11.5 12 11.5C14.2091 11.5 16 9.70914 16 7.5C16 5.29086 14.2091 3.5 12 3.5Z"
        fill="#333333"
      />
      <path
        d="M13.3609 15H9.68125C7.93994 15 6.25269 15.6021 4.99428 16.6992C3.73261 17.7991 2.99988 19.3148 2.99988 20.9209V22H14.2711C14.2169 21.9499 14.1634 21.8986 14.1108 21.8459C13.704 21.4391 13.3742 20.9844 13.1215 20.5H4.52355C4.63483 19.5123 5.13626 18.5654 5.97999 17.8299C6.94627 16.9875 8.27636 16.5 9.68125 16.5H12.6954C12.8385 15.9767 13.0604 15.4705 13.3609 15Z"
        fill="#333333"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.8283 20.7853C19.2662 22.3474 16.7336 22.3474 15.1715 20.7853C13.6094 19.2232 13.6094 16.6905 15.1715 15.1284C16.7336 13.5663 19.2662 13.5663 20.8283 15.1284C22.3904 16.6905 22.3904 19.2232 20.8283 20.7853ZM19.1195 15.7766L16.9982 17.898L18.0589 18.9586L20.1802 16.8373L19.1195 15.7766ZM16.1143 19.8425L17.3518 19.6657L16.2911 18.6051L16.1143 19.8425Z"
        fill="#333333"
      />
    </svg>
  );
};

IconAccountEdit.defaultProps = { className: null };

IconAccountEdit.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconAccountEdit;
